import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Save } from 'lucide-react';
import usePageContent from './usePageContent';
import PageHeroEditor from './PageHeroEditor';
import LivePreviewPanel, { ResourcesPreview } from './LivePreviewPanel';

const defaults = {
  hero: {
    title: 'Resources &',
    highlight: 'Documents',
    description:
      'Access important documents, policies, and resources for our members.',
  },
  empty: {
    heading: 'No resources available in this category.',
    body_markdown: 'Please check back soon for new publications and resources.',
  },
};

const ResourcesContentEditor = () => {
  const [showPreview, setShowPreview] = useState(false);
  const { loading, saving, sections, setSections, saveSection } = usePageContent({
    pageName: 'resources',
    defaultsBySection: defaults,
  });

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Live Preview Panel */}
      <LivePreviewPanel 
        pageName="resources" 
        showPreview={showPreview} 
        setShowPreview={setShowPreview}
      >
        <ResourcesPreview content={sections} />
      </LivePreviewPanel>

      <PageHeroEditor
        title={sections.hero.title}
        setTitle={(v) => setSections({ ...sections, hero: { ...sections.hero, title: v } })}
        highlight={sections.hero.highlight}
        setHighlight={(v) => setSections({ ...sections, hero: { ...sections.hero, highlight: v } })}
        description={sections.hero.description}
        setDescription={(v) => setSections({ ...sections, hero: { ...sections.hero, description: v } })}
        onSave={() => saveSection('hero')}
        saving={saving}
      />

      <Card>
        <CardHeader>
          <CardTitle>Empty State</CardTitle>
          <CardDescription>Text shown when no resources are available</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <Label>Heading</Label>
            <Input
              value={sections.empty.heading}
              onChange={(e) => setSections({ ...sections, empty: { ...sections.empty, heading: e.target.value } })}
              className="mt-1"
            />
          </div>
          <div>
            <Label>Body (Markdown)</Label>
            <Textarea
              value={sections.empty.body_markdown}
              onChange={(e) => setSections({ ...sections, empty: { ...sections.empty, body_markdown: e.target.value } })}
              className="mt-1"
              rows={2}
            />
          </div>
          <Button
            type="button"
            onClick={() => saveSection('empty')}
            disabled={saving}
            className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700"
          >
            <Save className="mr-2" size={18} /> Save Empty State
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default ResourcesContentEditor;
